<template>
  <v-flex xs12 lg6>
    <v-menu
      :close-on-content-click="true"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
    >
      <v-text-field
      slot="activator"
      v-model="dateFormatted"
      label="Data Final"
      :hint="`Padrão: ${model}`"
      persistent-hint
      prepend-icon="event"
      ></v-text-field>
      <v-date-picker v-model="finalDate" no-title @input="updateFinalDate"></v-date-picker>
    </v-menu>
  </v-flex>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'InitialDate',
  computed: {
    dateFormatted() {
      return moment(this.finalDate).format('DD/MM/YYYY');
    },
    finalDate: {
      get() {
        return this.model;
      },
      set(newDate) {
        this.updateFinalDate(newDate);
        this.model;
      },
    },
    ...mapGetters({
      model: 'deposits/finalDate',
    }),
  },
  methods: {
    ...mapActions({
      updateFinalDate: 'deposits/updateFinalDate',
    }),
  },
};
</script>
